import { useContext } from 'react'
import IndexContext from '../context/IndexProvider'

const useIndex = () => {
  return useContext(IndexContext)
}

export default useIndex